import { RequerimientoModalForm } from './RequerimientoModalForm';
import { RequerimientoModalContent } from './RequerimientoModalContent';
import { RequerimientoModalImages } from './RequerimientoModalImages';
import { RequerimientoModalAnular } from './RequerimientoModalAnular';
import { RequerimientoModalConfirmar } from './RequerimientoModalConfirmar';

export const getRequerimientoModal = (action, payload = {}) => {
  switch (action) {
    case 'view':
      return <RequerimientoModalContent {...payload} />;
    case 'add':
    case 'edit':
      return <RequerimientoModalForm {...payload} />;
    case 'images':
      return <RequerimientoModalImages {...payload} />;
    case 'anular':
      return <RequerimientoModalAnular {...payload} />;
    case 'reenviar': {
      const { requerimiento, closeSecondModal, ...rest } = payload;
      return (
        <RequerimientoModalConfirmar
          requerimiento={requerimiento}
          onClose={closeSecondModal}
          {...rest}
        />
      );
    }
    default:
      return null;
  }
};
